var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_logo_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebars",
    transform: "translate(-488, -203)",
    fill: "#BFE82D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(470, 124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0279971,106.767991 L49.0279971,91.2763282 C49.0279971,89.4626093 47.5573821,87.9922996 45.7432865,87.9922996 C43.929191,87.9922996 42.458576,89.4626093 42.458576,91.2763282 L42.458576,106.767991 C42.4502256,107.869708 42.3012617,108.965854 42.0152952,110.02986 C41.3447621,112.465356 39.9354431,114.633089 37.9814402,116.234502 C35.8192941,118.063194 33.0667405,119.045089 30.2351086,118.997784 C24.7416646,118.984396 19.9278403,115.318862 18.454922,110.027644 C18.142625,108.968874 17.989497,107.869568 18.0005592,106.765775 L18.0005592,91.2763282 C17.9925496,90.158177 18.1455731,89.0446955 18.454922,87.9701402 C19.9428568,82.6891153 24.7475023,79.0305703 30.2351086,79 L30.2351086,87.9701402 C28.4301363,88.0038078 26.9818762,89.4714406 26.9725621,91.2763282 L26.9725621,106.767991 C26.9725621,108.569471 28.4332539,110.02986 30.2351086,110.02986 C32.0369633,110.02986 33.4976551,108.569471 33.4976551,106.767991 L33.4976551,91.2763282 C33.5079744,90.1601699 33.6568738,89.0496113 33.9409359,87.9701402 C34.6290588,85.5549166 36.0350558,83.4057875 37.9725745,81.8076007 C39.3028702,80.7424048 40.8259558,79.9434023 42.458576,79.4542685 C43.5221068,79.1635909 44.6186221,79.010915 45.7211225,79 C51.2189001,79.0294014 56.0369835,82.6844252 57.5456372,87.9701402 C57.8334402,89.0491404 57.9860631,90.1597067 58,91.2763282 L58,106.767991 C57.9890828,107.870262 57.8363751,108.96655 57.5456372,110.02986 C56.0525321,115.326188 51.2249367,118.988428 45.7211225,119 L45.7211225,110.02986 C47.5263849,110.020548 48.9943224,108.572588 49.0279971,106.767991 L49.0279971,106.767991 Z",
    id: "ic_logo_small"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoSmall);
export default __webpack_public_path__ + "static/media/ic_logo_small.dda8fa220d1d5d763a8d8d0489bf7b4f.svg";
export { ForwardRef as ReactComponent };